import { render, staticRenderFns } from "./CreateTransection.vue?vue&type=template&id=2ec78b40&"
import script from "./CreateTransection.vue?vue&type=script&lang=js&"
export * from "./CreateTransection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports